/* eslint-disable no-undef */
import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import notify from './notify';
import history from '../history';
import { usuarioLogueado } from './loggedInfo';

const withAuthInfo = ({
  requireUserId,
  requireRole
} = {}) => ChildComponent =>
  connect(({ authInfo }) => ({ authInfo }))(props => {
    const { t: notifications } = useTranslation('notifications');

    // eslint-disable-next-line react/prop-types
    const {
      rol,
      nombreUsuario,
      usuarioId,
      clienteId,
      plazaId,
      nominaManejar,
      sucursalesAsociadas,
      conceptoPrenominas
    } = usuarioLogueado();

    if (requireRole && rol !== requireRole) {
      history.push('/dashboard');
    }

    if (requireUserId && !usuarioId) {
      history.push('/dashboard');
      if (process.env.REACT_APP_STAGE === 'dev')
        notify({
          t: notifications,
          type: 'warn',
          textMessage: notifications('USER_ID_REQUIRED'),
          payload: ''
        });
    }

    return (
      <ChildComponent
        {...props}
        authInfo={{
          rol,
          nombreUsuario,
          usuarioId,
          clienteId,
          plazaId,
          nominaManejar,
          sucursalesAsociadas,
          conceptoPrenominas
        }}
      />
    );
  });

export default withAuthInfo;
